import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationsTR from "./lang/tr.json";
import translationsEN from "./lang/en.json";
import translationsZH from "./lang/zh.json";
import translationsRU from "./lang/ru.json";
import translationsDE from "./lang/de.json";

const SUPPORTED = ["tr", "en", "de", "ru", "zh"];

function initialLanguage() {
  try {
    const saved = localStorage.getItem("kodpilot-lang");
    if (SUPPORTED.includes(saved)) return saved;
  } catch {
    return "tr";
  }
  return "tr";
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: translationsTR },
      en: { translation: translationsEN },
      zh: { translation: translationsZH },
      ru: { translation: translationsRU },
      de: { translation: translationsDE },
    },
    lng: initialLanguage(),
    fallbackLng: "tr",
    supportedLngs: SUPPORTED,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  const code = String(lng || "tr").slice(0, 2);
  try {
    localStorage.setItem("kodpilot-lang", code);
  } catch {
    /* private mode */
  }
  document.documentElement.lang = code;
});

export default i18n;
